<script>
    import { mapState } from "vuex";
    import { formatPrice } from "@/utils";
    import { FREE_DELIVERY_LIMIT } from "@/settings/constants";

    export default {
        name: "HomeAdvantages",
        computed: {
            ...mapState("Root", {
                freeDeliveryCount: (state) => state.site.freeDelivery,
            }),
            hasFreeDelivery() {
                return this.freeDeliveryCount < FREE_DELIVERY_LIMIT;
            },
            list() {
                const list = [
                    { name: "Свежая <span>зелень дома</span>", icon: "herbal" },
                    { name: "1 год <span>гарантии</span>", icon: "guarantee" },
                    { name: "Заботливый <span>клиентский сервис</span>", icon: "service" },
                ];

                if (this.hasFreeDelivery) {
                    list.push({
                        name: `Бесплатная доставка <span>от <nobr>${formatPrice(
                            this.freeDeliveryCount
                        )}&nbsp;₽</nobr></span>`,
                        icon: "delivery",
                    });
                }

                return list;
            },
        },
    };
</script>

<template>
    <section class="home-advantages" :class="{ 'is-limited': !hasFreeDelivery }">
        <div class="home-advantages__item" v-for="(item, index) in list" :key="index">
            <img
                class="home-advantages__icon"
                :src="`/static/igarden/home/advantages/${item.icon}.svg`"
                alt=""
            />
            <span v-html="item.name"></span>
        </div>
    </section>
</template>

<style lang="scss">
    .home-advantages {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding-top: 30px;
        background-image: linear-gradient(116.13deg, #f1fcfa 11.33%, #fcfff4 101.32%);
        border-radius: var(--border-lg);
        &.is-limited {
            .home-advantages__item {
                width: 100%;
                span {
                    display: inline-block;
                }
            }
            @include bp_max($bp-desktop-sm_max) {
                display: block;
                .home-advantages__item {
                    display: flex;
                    align-items: center;
                    max-width: 100%;
                    text-align: left;
                }
                .home-advantages__icon {
                    margin: 0 10px 0 0;
                }
            }
        }
        @include bp($bp-desktop-sm) {
            padding: 28px 50px;
            border-radius: var(--border-xl);
        }
    }

    .home-advantages__item {
        flex-basis: 50%;
        max-width: 50%;
        padding: 0 8px 30px;
        font-size: 14px;
        font-weight: 300;
        line-height: 20px;
        text-align: center;
        span {
            display: block;
        }
        @include bp($bp-desktop-sm) {
            flex-basis: 25%;
            max-width: 25%;
            display: flex;
            align-items: center;
            padding-bottom: 0;
            text-align: left;
        }
    }

    .home-advantages__icon {
        width: 56px;
        height: 50px;
        margin: 0 auto 4px;
        @include bp($bp-desktop-sm) {
            width: 95px;
            height: 84px;
            margin: 0 15px 0 0;
        }
    }
</style>
